import { ProfileSizes } from "@ecologi/shared";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

export type ProfileAvatarProps = {
  alt: string;
  src: string;
  className?: string;
  size?: ProfileSizes;
};

const Container = styled.div<{ size?: ProfileSizes }>`
  border-radius: 50%;
  display: block;
  height: 136px;
  width: 136px;
  margin: 20px auto 10px;
  outline: none;
  position: relative;
  background-color: ${({ theme }) => theme.colors.snowdrop};

  @media ${(props) => props.theme.bp.tabletUp} {
    height: 163px;
    width: 163px;
  }

  ${(props) =>
    props.size === ProfileSizes.LARGE ||
    (props.size === ProfileSizes.XLARGE &&
      css`
        margin-bottom: 20px;
        height: 240px !important;
        width: 240px !important;
      `)}

  ${(props) =>
    props.size === ProfileSizes.SMALL &&
    css`
      display: inline-block;
      left: 10px;
      height: 32px !important;
      width: 32px !important;
    `}
`;

const Image = styled.img`
  background: ${(props) => props.theme.colors.snowdrop};
  border-radius: 50%;
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const ProfileAvatar = ({
  alt,
  src,
  size = ProfileSizes.DEFAULT,
  ...rootProps
}: ProfileAvatarProps) => {
  return (
    <Container size={size} {...rootProps} id="profile-avatar">
      <Image alt={alt} src={src} />
    </Container>
  );
};

ProfileAvatar.Image = Image;
ProfileAvatar.Container = Container;
